// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2xPOh","title":"AfterFrontImage_title__Q0xSS"};